import { assign } from 'xstate';
import { PaymentsContext } from './paymentsMachine';
import {
  PaymentMachineEvents,
  SendAssignSelectedPaymentMethodParams,
} from './types/events';
import {
  CreatePaymentMethodResult,
  FetchPaymentMethodResult,
  FetchPaymentMethodsResult,
} from './types/actors';
import { getPaymentMethodResult } from './utils';

/**
 * Assigns payment method result to context for events
 * `SEND_FETCH_PAYMENT_METHOD` and `SEND_CREATE_PAYMENT_METHOD`
 */
export const assignPaymentMethodResult = assign<
  PaymentsContext,
  PaymentMachineEvents,
  FetchPaymentMethodResult | CreatePaymentMethodResult,
  PaymentMachineEvents,
  never
>({
  selectedPaymentMethodID: (_, event) => {
    const paymentMethodID = getPaymentMethodResult(event)?.id ?? null;
    return paymentMethodID;
  },
  paymentMethods: ({ context }, event) => {
    const paymentMethod = getPaymentMethodResult(event);

    if (!paymentMethod) {
      return context.paymentMethods;
    }

    return [
      paymentMethod,
      ...context.paymentMethods.filter((pm) => pm.id !== paymentMethod.id),
    ];
  },
});

/**
 * Assigns selected payment method to context for event `SEND_ASSIGN_SELECTED_PAYMENT_METHOD`
 */
export const assignSelectedPaymentMethod = assign<
  PaymentsContext,
  PaymentMachineEvents,
  SendAssignSelectedPaymentMethodParams,
  PaymentMachineEvents,
  never
>({
  selectedPaymentMethodID: (_, event) => {
    return event.selectedPaymentMethodID;
  },
});

/**
 * Assigns payment methods to context for event `SEND_FETCH_PAYMENT_METHODS`
 */
export const assignPaymentMethodsResult = assign<
  PaymentsContext,
  PaymentMachineEvents,
  FetchPaymentMethodsResult,
  PaymentMachineEvents,
  never
>({
  paymentMethods: (_, event) => {
    return event.paymentMethodsRes.result?.paymentMethods ?? [];
  },
});
